<div *ngIf="warrantyVehicle && warrantyVehicle.model && warrantyVehicle.make && warrantyVehicle.year && warrantyVehicle.vin && (warrantyError$| async) === false">
  <div class="gb-color-grey-mid-dark gb-small-margin">
    <span class="gb-body1 mb-1" [translateParams]="{refreshDate: refreshDate}"
          [translate]="'recallCenter_lastUpdated_label'">
    </span>
  </div>
  <div class="gb-headline2 mb-3" role="heading" aria-level="2">
    <p class="mb-1">{{warrantyVehicle.year}} {{warrantyVehicle.make}} {{warrantyVehicle.model}}</p>
  </div>
  <div class="gb-descriptive1 mb-6">
    <p class="mb-0" [translateParams]="{searchedVin: warrantyVehicle.vin}"
       [translate]="'recallCenter_vin_label'"></p>
  </div>
  <div *ngIf="updateOdometerError$ | async" ox-alert type="error">
    <span aria-atomic="true" role="alert" [translate]="'activeVehicle_addMileageErrorMsg'"></span>
  </div>

  <div class="d-flex flex-column flex-lg-row justify-content-lg-between justify-content-start">
    <div class="flex-fill">
      <div class="gb-body2">
        <p class="mb-0">{{'ma_recalls_warranty_mileage' | translate}}</p>
      </div>
      <div *ngIf="!updateMilesInputToggle">
        <div class="gb-body2 my-1 heavy">
          <p>{{odometer | number}} {{'ma_recalls_warranty_miles' | translate}}</p>
        </div>
        <div class="gb-body2 mb-2">
          <p class="mb-1">{{'ma_recalls_warranty_mileage_text' | translate}}</p>
        </div>
      </div>

      <div *ngIf="updateMilesInputToggle" class="mt-3 mb-1">
        <div class="row">
          <div class="col-sm-12 col-md-8">
            <ox-text-input
              [inputName]="'mileage'"
              [classes]="'form-control'"
              [required]="'true'"
              [validationType]="'numeric'"
              [id]="'updateMileage'"
              [placeHolderText]="odometer"
              [formGroupInput]="mileageUpdateForm"
              [formControlNameInput]="'mileageInput'"
              [maxLength]="odometerAttributes.maxlength"
              [label]="'ma_recalls_enter_mileage_label'">
            </ox-text-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-sm-12">
            <button
              (click)="updateMileageSave(mileageUpdateForm.value)"
              [translate]="'ma_save_mileage_btn'"
              [disabled]="mileageUpdateForm.invalid"
              [attr.aria-disabled]="mileageUpdateForm.invalid"
              class="gb-primary-button my-2">
            </button>
          </div>
        </div>
      </div>

      <div *ngIf="warrantyVehicle.odometerLastUpdated !== invalidDate && warrantyVehicle.odometerLastUpdated" class="gb-label gb-color-grey-mid-dark">
        <p class="mb-0" *ngIf="auth$ | async">{{'ma_recalls_odometer_lastUpdated' | translate}} {{warrantyVehicle.odometerLastUpdated | date: 'longDate'}}</p>
      </div>
    </div>

    <div class="gb-body2 mt-4 mt-lg-0">
      <a href="javascript:void(0);" (click)="toggleMilesDisplayInput()">{{mileageLabel | translate}}</a>
    </div>
  </div>
  <hr/>
</div>
